import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useLang } from "../contexts/LanguageContext";

export const BreederCard = ({ breeder }) => {
  const { t } = useLang();
  return (
    <Link to={`/breeder/${breeder.slug}`} data-testid={`breeder-card-${breeder.slug}`} className="card-luxury group block">
      <div className="image-zoom aspect-[16/9] overflow-hidden bg-black relative">
        <img src={breeder.cover} alt={breeder.name} loading="lazy" className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
        <div className="absolute bottom-4 left-5 right-5 flex items-end justify-between">
          <div>
            <div className="overline">{breeder.location}</div>
            <h3 className="font-display text-xl text-white tracking-tight mt-1">{breeder.name}</h3>
          </div>
          {breeder.verified && (
            <div className="flex items-center gap-1 text-[10px] uppercase tracking-[0.2em] text-[var(--monzal-emerald)] font-display">
              <ShieldCheck size={12} /> {t("breeder.verified")}
            </div>
          )}
        </div>
      </div>
      <div className="p-5">
        <p className="text-sm text-gray-400 leading-relaxed min-h-[3rem]">{breeder.bio}</p>
        <div className="flex items-center justify-between mt-5 pt-4 border-t border-white/5">
          <div className="flex gap-2 flex-wrap">
            {breeder.specialties.slice(0, 2).map((s) => <span key={s} className="tag-tech">{s}</span>)}
          </div>
          <div className="font-mono-tech text-xs text-[var(--monzal-gold)]">
            {breeder.years_active} {t("breeder.yearsActive")}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default BreederCard;
